import React, { useEffect, useState, useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { withRouter } from 'react-router'
import { Flex } from 'reflexbox'
import IconButton from '@material-ui/core/IconButton'
import SearchIcon from '@material-ui/icons/Search'
import CloseIcon from '@material-ui/icons/Close'
import AddIcon from '@material-ui/icons/Add'

import SearchField from './SearchField.jsx';
import SearchTabs from './SearchTabs.jsx';
import {
  FabIcon,
  SearchContainer,
  ButtonContainer,
} from '../../healtheraComponents';

import { ROUTES } from '../Routes/constants'
import { getPreviousPageNameByUrl } from '../../helpers';
import {
  selectDisplayAddButton,
  selectDisplayMenu,
  selectDisplaySearch,
} from '../../redux/options/selectors';
import { setDisplayAddButton, setDisplayMenu, setDisplaySearch } from '../../redux/options/actions';
import * as orgActions from '../../redux/organisations';
import useLocationQuery from '../../hooks/useQuery.js';

function Search({ location, history }) {
  const dispatch = useDispatch();

  const displayMenu = useSelector(selectDisplayMenu);
  const displaySearch = useSelector(selectDisplaySearch);
  const displayAddButton = useSelector(selectDisplayAddButton);
  // TO-DO: Remove dependency inversion (get rid of any organisation references);
  const { organisationCounts, statusActiveFilter } = useSelector(({ organisations }) => organisations);
  const { orgID } = useSelector(({ authentication }) => authentication);

  const [displaySearchField, setDisplaySearchField] = useState(false);
  const [superRouteState, setSuperRouteState] = useState(ROUTES.ORGANISATIONS);
  const shouldHideSearch = location.pathname.includes('dashboard');

  const { query, changeLocationQuery } = useLocationQuery();

  useEffect(() => {
    if (!query.search) {
      setDisplaySearchField(false);
      dispatch(setDisplayMenu(true));
      dispatch(setDisplaySearch(true));
      dispatch(setDisplayAddButton(displayAddButton));
      dispatch(orgActions.resetSearchResults())
    } else if (!shouldHideSearch) {
      setDisplaySearchField(true)
      if (query.search.length > 2) {
        dispatch(orgActions.search({ searchTerm: query.search }));
      }
    }
  }, [query.search, dispatch, statusActiveFilter, shouldHideSearch, displayAddButton]);

  useEffect(() => {
    const updateSuperRoute = pathname => {
      const superRoute = pathname.split('/')[1] || '';
      const superRoutePath = ['', superRoute].join('/');
      setSuperRouteState(superRoutePath);
    };

    const handleLocationChange = location => {
      //don't listen if there are query params
      if (location.search) {
        if(location.pathname === '/organisations' && superRouteState === '/branches') {
          setSuperRouteState('/organisations')
        }
        return;
      }

      dispatch(setDisplaySearch(['/organisations'].includes(location.pathname)));
      dispatch(setDisplayAddButton(['/organisations', '/announcements', '/services'].includes(location.pathname)))

      const route = location.pathname;
      const routePaths = route.split('/');
      // /organisations/id <- subUrl, because it has a super url 'organisations'
      const isSubRoute = routePaths.length > 2;

      // Reset settings on each url change
      dispatch(setDisplayMenu(!isSubRoute));
      setDisplaySearchField(false);
      updateSuperRoute(location.pathname);
    };

    handleLocationChange(location);

    return history.listen(handleLocationChange);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history, location, dispatch ]);

  const goBack = useCallback(() => {
    if (location.state?.goBackLinks?.length) {
      const { goBackLinks } = location.state;
      const poppedGoBackLinks = [...goBackLinks];
      const goBackLink = poppedGoBackLinks.pop();
      return history.push(goBackLink, { goBackLinks: poppedGoBackLinks });
    }

    const newUrl = location.pathname
      .split('/')
      .slice(0, -1)
      .join('/');

    history.push(newUrl, { canGoBack: false });

    dispatch(setDisplaySearch(true));
  }, [history, dispatch, location]);

  const handleViewChange = ({ target: { value: route } }) => {
    history.push(route);
  };

  const handleSearch = (term) => changeLocationQuery({ search: term });
  const handleOpenSearch = (term) => setDisplaySearchField(true);

  const handleCloseSearch = () => {
    if(query.search){
      return changeLocationQuery({})
    }
    setDisplaySearchField(false)
  };

  const handleAddButtonClick = useCallback(() => {
    history.push([superRouteState, 'create'].join('/'));
  }, [history, superRouteState]);

  const previousPage = useMemo(() => {
    return getPreviousPageNameByUrl(location.pathname);
  }, [location.pathname]);

  if (orgID) return null;

  return (
    <SearchContainer>
      <Flex w={`100%`}>
        {!displaySearchField && (
          <SearchTabs
            tabCounts={organisationCounts}
            onGoBack={goBack}
            onViewChange={handleViewChange}
            superRoute={superRouteState}
            previousPage={previousPage}
            displayMenu={displayMenu}
          />
        )}

        {displaySearchField && <SearchField onSearch={handleSearch} />}

        <ButtonContainer w={3 / 10}>
          {!displaySearchField && displaySearch && (
            <IconButton disableRipple onClick={handleOpenSearch}>
              <SearchIcon />
            </IconButton>
          )}
          {displaySearchField && (
            <IconButton onClick={handleCloseSearch}>
              <CloseIcon />
            </IconButton>
          )}
          {displayAddButton && (
            <FabIcon onClick={handleAddButtonClick}>
              <AddIcon />
            </FabIcon>
          )}
        </ButtonContainer>
      </Flex>
    </SearchContainer>
  );
}

export default withRouter(Search)
